'use client';

import { FC } from 'react';
import { Content } from '@prismicio/client';
import { BoxContainer, Calculator, Container } from '@/components';
import { useVisible } from '@/hooks';
import { TextContent } from '../index';

import styles from './estimatePaymentInner.module.scss';
import { CalculatorProps } from '@/types';

type Props = {
  slice: Content.EstimatePaymentSlice;
};

export const EstimatePaymentInner: FC<Props> = ({ slice }) => {
  const [isVisible, id] = useVisible();

  const isVisibleStyles = isVisible ? styles.isVisible : '';

  const calculatorData: CalculatorProps = {
    variation: 'large',
    min: slice.primary.min,
    max: slice.primary.max,
    defaultValue: slice.primary.default_value,
    step: slice.primary.step,
    resultText: slice.primary.calculator_result_text,
    rateText: slice.primary.rate_text,
    rateValue: slice.primary.rate_value,
    timeLineText: slice.primary.time_line_text,
    timeLineValue: slice.primary.time_line_value,
    title: slice.primary.calculator_title,
    buttonText: slice.primary.button_link_text,
    buttonLink: slice.primary.button_link,
    rangeHeading: slice.primary.loan_text,
    plateText: slice.primary.apply_text,
    securityNotice: slice.primary.protected_text,
    buttonVariation: 'white',
    illustrativeText: slice.primary.illustrative_text,
  };

  return (
    <BoxContainer styles={styles.boxContainer}>
      <Container styles={styles.container}>
        <div className={styles.inner} id={id}>
          <TextContent slice={slice} isVisible={isVisible} />
          <div className={`${styles.calculatorWrapper} ${isVisibleStyles}`}>
            <Calculator data={calculatorData} />
          </div>
        </div>
      </Container>
    </BoxContainer>
  );
};
